export default __webpack_public_path__ + "static/media/bg9.38ac4fb0.jpg";